import { ref } from 'vue'

export const showUnauthenticatedToast = ref(false)
let isProcessing401 = false

export const setUnauthenticatedToast = () => {
  if (isProcessing401) return
  isProcessing401 = true
  showUnauthenticatedToast.value = true
}

export const clearToastRef = () => {
  showUnauthenticatedToast.value = false
}

export const resetUnauthenticatedState = () => {
  isProcessing401 = false
  showUnauthenticatedToast.value = false
}
